<template>
	<feature-item :image="product.avatar" :thumbnail="product.avatar_thumbnail" :title="product.name" :description="product.description" :selected="selected" :bordered="bordered"
				  :divided="divided" :disabled="disabled">

		<info-list v-if="product.stock" small class="mt-10">
			<info-list-item :icon="icons.stock" :text="$t('param_label.in_stock', product.stock, {count: product.stock})"/>
		</info-list>

		<check-list v-if="product.participationClasses && product.participationClasses.length" class="mt-10" small>
			<check-list-item v-for="participationClass in product.participationClasses" :key="participationClass.id" :text="participationClass.name"
							 :help="$t('text.product.valid_for_class', {participation_class: participationClass.name})" class="px-0"/>
		</check-list>

		<slot/>

		<template #info>
			<div class="flex flex-column justify-end items-end">
				<chip v-if="product.status.value !== 'published'" :color="product.status.color" :help="product.status.description" small>{{ product.status.title }}</chip>
				<template v-else>
					<template v-if="displayPrice">
						<template v-if="displayPrice.cents > 0 || hasMultipleActivePrices">
							<p class="text-success mb-0 text-sub leading-normal text-right text-md" v-html="hasMultipleActivePrices ? $t('label.start_price_per_unit', {price:
                        toEuro(displayPrice.cents), unit: $t('label.unit')}) : $t('label.price_per_unit', {price: toEuro(displayPrice.cents), unit: $t('label.unit')})"/>
							<p class="text-soft text-4xs leading-tight mb-0">
								{{ displayPrice.tax_percent ? $t('text.including_tax_and_fees', {tax: displayPrice.tax_percent}) : $t('text.including_fees') }}
							</p>
						</template>
						<p class="text-success text-sub mb-0 text-right text-uppercase" v-else>{{ $t('label.free') }}</p>

						<p v-if="displayPrice && displayPrice.available_purchases_count"
						   class="text-4xs text-warning mb-0">{{
								displayPrice.max_purchases === displayPrice.available_purchases_count ? $t('param_text.valid_for_the_next_count_purchases', displayPrice.available_purchases_count, {count: displayPrice.available_purchases_count}) : $t('param_text.valid_for_count_remaining_purchases', displayPrice.available_purchases_count, {count: displayPrice.available_purchases_count})
                        }}</p>

						<p v-if="lowestNextPrice && lowestActivePrice && lowestActivePrice.end_date && lowestNextPrice.id !== lowestActivePrice.id && lowestNextPrice.cents > lowestActivePrice.cents"
						   class="text-4xs text-warning mb-0">{{ $t('text.price.increase', {date: $date(lowestActivePrice.end_date).add(1, 'minute').format('LL')}) }}</p>
					</template>
					<template v-if="product.prices && product.prices.length">
						<span class="text-primary text-2xs cursor-pointer leading-tight mt-5" @click.prevent="showPriceDetailsModal = true">{{ $t('label.details') }}</span>
						<lazy-modal v-model="showPriceDetailsModal" :title="product.name" small>

							<p class="subheading text-sm text-left mb-16">{{ $t('label.participation_product_prices') }}</p>

							<lazy-price v-for="(price, priceIndex) in product.prices"
								   :active="!!activePrices.find(activePrice => activePrice.id === price.id)"
								   :inactive="!!activePrices.find(activePrice => activePrice.id === price.id)"
								   :set-prices="product.prices"
								   :price="price" :key="'price-' + priceIndex"/>

							<divider margin="16"/>

							<p class="subheading text-sm mb-16 text-left">{{ $t('label.cancel_conditions') }}</p>

							<template v-if="product.cancelConditions && product.cancelConditions.length">
								<lazy-cancel-condition v-for="(cancelCondition, index) in product.cancelConditions"
													   :cancel-condition="cancelCondition"
													   :active="cancelCondition.is_active"
													   :inactive="!cancelCondition.is_active"
												  :key="'cancel-condition-' + index"/>
							</template>
							<lazy-missing-info v-else :text="$t('missing.product.cancel_conditions')"/>

						</lazy-modal>
					</template>
				</template>
			</div>
		</template>

		<template #actions>
			<div v-if="$slots.actions" class="mt-20">
				<slot name="actions"/>
			</div>
		</template>
	</feature-item>
</template>

<script>
import {mdiPackageVariantClosed} from '@mdi/js';
    import HasPricesMixin from "../../mixins/HasPricesMixin";
    import {toEuro} from "@spoferan/spoferan-ts-core";

    export default {

        name: 'EventProduct',

        mixins: [HasPricesMixin('product')],

        props: {
            product: {
                type: Object,
                required: true
            },

            // Whether the product shall get a selected style
            selected: {
                type: Boolean,
                default: false
            },

            // Whether the product shall get a bordered style
            bordered: {
                type: Boolean,
                default: false
            },

            // Whether the product shall get a disabled style
            disabled: {
                type: Boolean,
                default: false
            },

            divided: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                showPriceDetailsModal: false,
                selectedQuantity: 1,
                icons: {stock: mdiPackageVariantClosed}
            }
        },

        methods: {
            toEuro(val) {
                return toEuro(val);
            },

        }
    }
</script>